// components/new_components/FlowButtons.jsx
"use client";

import { ReactComponent as ArrowRight } from "../../public/svg/ArrowRight2.svg";
import { ReactComponent as ArrowLeft } from "../../public/svg/ArrowLeft.svg";
import { ReactComponent as ArrowLeft2 } from "../../public/svg/ArrowLeft2.svg";
// ─── Botón Atrás────────────────────────────────────────────────
export const PrevButton = ({ onBack, label = "Atrás", isMobile = false }) => (
  <button
    type="button"
    onClick={onBack}
    style={{
      height: "clamp(48px, 5vh, 56px)",
      borderRadius: "2.5rem",
      fontSize: "1.2rem",
      fontWeight: "400",
      color: "#A68AFF",
      cursor: "pointer"
    }}
    className="flex items-center justify-center gap-3 px-4 py-3 hover:transition-colors duration-200 flex-1 text-base font-semibold2"
  >
    <ArrowLeft className={"w-6 h-6"} />
    <p>{label}</p>
  </button>
);
// ─── Botón Siguiente / Finalizar ────────────────────────────────
export const NextButton = ({
  onNext,
  label = "Continuar",
  finishLabel,
  isLastStep = false,
  isLoading = false,
  disabled = false,
  errors = false,
  isResume = false,
  isMobile = false,
  showIconNext = true,
  isBancolombiaIcon = false,
  isUnicButtom = false,
  logo,
  typeButton = "button",
}) => {
  const isDisabled = isLoading || errors || disabled;

  return (
    <button
      type={typeButton}
      onClick={onNext}
      disabled={isDisabled}
      style={{
        height: "clamp(48px, 5vh, 56px)",
        borderRadius: isMobile ? "2.5rem" : "2rem",
        fontSize: isMobile ? "1.2rem" : "clamp(14px, 1.1vw, 16px)",
        fontWeight: isMobile ? "400" : "500",
        padding: "0 clamp(28px, 3vw, 40px)",

        minWidth: isMobile ? "unset" : "clamp(140px, 14vw, 180px)",
        flex: isMobile ? 1 : "unset", // ← ocupa todo el ancho en mobile
        cursor: !isDisabled ? "pointer" : "not-allowed",
        backgroundColor: !isDisabled ? "#7E02FC" : "#2C2447",
        width: isUnicButtom ? "100%" : "unset",
      }}
      className="flex items-center justify-center gap-3 transition-all duration-200 text-white hover:bg-purpleDark font-semibold2"
    >
      {isLoading ? (
        <>
          <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
          Viajando...
        </>
      ) : isLastStep && finishLabel ? (
        <>
          <p style={{ fontSize: isMobile ? "1.5rem" : "1.2rem" }}>
            {finishLabel}
          </p>
          {showIconNext && <ArrowRight className={"w-6 h-6"} />}
        </>
      ) : (
        <>
          {isResume && <ArrowLeft2 className={"w-6 h-6"} />}
          <p
            style={{
              fontSize: isMobile
                ? isBancolombiaIcon
                  ? "1rem"
                  : "1.3rem"
                : "1.1rem",
            }}
          >
            {label}
          </p>
          {!isBancolombiaIcon && !isResume && showIconNext && (
            <ArrowRight className={"w-6 h-6"} />
          )}

          {isBancolombiaIcon && (
            <>
              {logo}
              {/* <ExternalLinkOutline
                className={isMobile ? "w-6 h-6" : "w-6 h-6"}
              /> */}
            </>
          )}
        </>
      )}
    </button>
  );
};

// ─── Wrapper para usarlos juntos ────────────────────────────────
export const FlowActions = ({
  onNext,
  onBack,
  nextLabel,
  finishLabel,
  isLastStep,
  isLoading,
  disabled,
  errors,
  isResume,
  showPrev = true,
  gap = "0px",
  width = "-webkit-fill-available",
}) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: gap,
      width: width,
    }}
  >
    {showPrev && <PrevButton onBack={onBack} />}
    <NextButton
      onNext={onNext}
      label={nextLabel}
      finishLabel={finishLabel}
      isLastStep={isLastStep}
      isLoading={isLoading}
      disabled={disabled}
      errors={errors}
      isResume={isResume}
    />
  </div>
);
